import './Timer.css';

export default function Timer({ remaining, warning = 30, danger = 10 }) {
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  const display = minutes > 0
    ? `${minutes}:${String(seconds).padStart(2, '0')}`
    : `${seconds}`;

  const classes = [
    'timer',
    remaining <= danger && 'timer--danger',
    remaining <= warning && remaining > danger && 'timer--warning',
  ].filter(Boolean).join(' ');

  return <span className={classes}>{display}</span>;
}
